const InvoiceStatCard = ({ icon, title, value }) => {
  return (
    <div className="w-full bg-white dark:bg-shoorah-darkBgTabColor border border-[#E7E8EA] dark:border-transparent rounded-lg">
      <div className="p-3">
        <div className="flex items-center gap-5">
          <div className="w-14 h-14 rounded-full bg-[#F1F1F1] flex items-center justify-center flex-shrink-0">
            <img src={icon} className="w-7 h-7 object-contain" alt={title} />
          </div>
          <div className="p-0">
            <h5 className="text-sm font-medium text-black dark:text-white">
              {title}
            </h5>
            <h2 className="text-2xl font-bold text-black dark:text-white">
              {value}
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceStatCard;
